import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {
  ConversationLingeringRuleModel,
  LingeringWorkloadTypesEnum,
} from '../../../../models/api/conversationLingeringRuleModel';
import {TriggerButton} from './triggerButton';

interface LingeringRuleButtonProps {
  lingeringRule: ConversationLingeringRuleModel;
}

export const LingeringRuleButton: FC<LingeringRuleButtonProps> = ({lingeringRule}) => (
  <TriggerButton isLoading title={renderWorkloadTitle(lingeringRule)} />
);

function renderWorkloadTitle(lingeringRule: ConversationLingeringRuleModel) {
  switch (lingeringRule.workloadType) {
    case LingeringWorkloadTypesEnum.AI_DRAFT_REPLY:
      return <Trans id="lingering-rule-workload-ai-draft-reply">Preparing reply</Trans>;

    case LingeringWorkloadTypesEnum.MACRO:
      return lingeringRule.ruleName;

    case LingeringWorkloadTypesEnum.FALLBACK_UNKNOWN:
    default:
      return <Trans id="lingering-rule-workload-unknown">Processing</Trans>;
  }
}
